"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerConfigurationValidation = void 0;
class ChargerConfigurationValidation {
    static isValid(entity) {
        // Validate entity.charger_powernode_ConnectedCharger_json for existence and correct type.
        if (entity.charger_powernode_ConnectedCharger_json == undefined)
            return false;
        if (typeof entity.charger_powernode_ConnectedCharger_json !== "string")
            return false;
        // Validate entity.time_offset_from_utc_seconds for existence and correct type.
        if (entity.time_offset_from_utc_seconds == undefined)
            return false;
        if (typeof entity.time_offset_from_utc_seconds !== "number")
            return false;
        // Validate entity.charger_power_hard_cap_kw for existence and correct type.
        if (entity.charger_power_hard_cap_kw == undefined)
            return false;
        if (typeof entity.charger_power_hard_cap_kw !== "number")
            return false;
        // Validate entity.ui_charger_ChargerUiConfig_json for existence and correct type.
        if (entity.ui_charger_ChargerUiConfig_json == undefined)
            return false;
        if (typeof entity.ui_charger_ChargerUiConfig_json !== "string")
            return false;
        // If entity.station_membership_enabled exists, validate that it has the correct type.
        if (entity.station_membership_enabled != undefined) {
            if (typeof entity.station_membership_enabled !== "boolean")
                return false;
        }
        // If entity.restrict_to_ocpp_ocpi_auth exists, validate that it has the correct type.
        if (entity.restrict_to_ocpp_ocpi_auth != undefined) {
            if (typeof entity.restrict_to_ocpp_ocpi_auth !== "boolean")
                return false;
        }
        // If entity.employees_only_access exists, validate that it has the correct type.
        if (entity.employees_only_access != undefined) {
            if (typeof entity.employees_only_access !== "boolean")
                return false;
        }
        return true;
    }
}
exports.ChargerConfigurationValidation = ChargerConfigurationValidation;
